module.exports = __webpack_public_path__ + "img/product_84.6e25bd0.svg";